export default __webpack_public_path__ + "static/media/ZW.ad4af813.svg";